import { useLazyQuery } from '@occc-app/dataAccessLayer/utils';
import { useSegmentsLazyQuery } from '@occc/graphql';

import { transformDataToSegmentsArray } from '../utils/transform-data-to-segments-array';

export const useGetSegmentsLazy = () => {
  const [executeQuery, response] = useLazyQuery(useSegmentsLazyQuery);

  return {
    executeQuery,
    response: {
      loading: response.loading,
      data: response.data ? transformDataToSegmentsArray(response.data) : [],
    },
  };
};
